var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.25 7c0-2.619 2.131-4.75 4.75-4.75s4.75 2.131 4.75 4.75-2.131 4.75-4.75 4.75-4.75-2.131-4.75-4.75zm7.75 6.25h-6c-3.17 0-5.75 2.58-5.75 5.75 0 1.517 1.233 2.75 2.75 2.75h12c1.517 0 2.75-1.233 2.75-2.75 0-3.17-2.58-5.75-5.75-5.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.dc8fa4cd46051b537fcf9019bcdca4c9.svg";
export { ForwardRef as ReactComponent };